var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11,
    fill: "#E74C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7068 5.55773L12.4311 14.0047H10.4259L10.1418 5.55773H12.7068ZM10.075 16.6198C10.075 16.2633 10.1975 15.9681 10.4426 15.7342C10.6933 15.4946 11.0219 15.3749 11.4285 15.3749C11.8407 15.3749 12.1693 15.4946 12.4144 15.7342C12.6595 15.9681 12.782 16.2633 12.782 16.6198C12.782 16.9651 12.6595 17.2576 12.4144 17.4971C12.1693 17.7366 11.8407 17.8563 11.4285 17.8563C11.0219 17.8563 10.6933 17.7366 10.4426 17.4971C10.1975 17.2576 10.075 16.9651 10.075 16.6198Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedWarningIcon);
export default __webpack_public_path__ + "static/media/RedWarningIcon.6d8ce92483c6ae8251d09045431ee8cc.svg";
export { ForwardRef as ReactComponent };